import { render, staticRenderFns } from "./MipDiagnosisRows.vue?vue&type=template&id=a8135f9c&scoped=true"
import script from "./MipDiagnosisRows.vue?vue&type=script&lang=js"
export * from "./MipDiagnosisRows.vue?vue&type=script&lang=js"
import style0 from "./MipDiagnosisRows.vue?vue&type=style&index=0&id=a8135f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8135f9c",
  null
  
)

export default component.exports